// @module Ames.InventoryOverride.InventoryOverride
define('Ames.InventoryOverride.InventoryOverride.View'
,	[
	'ames_inventoryoverride_inventoryoverride.tpl'
	
	,	'Ames.InventoryOverride.InventoryOverride.SS2Model'
	
	,	'Backbone'
    ]
, function (
	ames_inventoryoverride_inventoryoverride_tpl
	
	,	InventoryOverrideSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class Ames.InventoryOverride.InventoryOverride.View @extends Backbone.View
	return Backbone.View.extend({

		template: ames_inventoryoverride_inventoryoverride_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new InventoryOverrideModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Ames.InventoryOverride.InventoryOverride.View.Context
	,	getContext: function getContext()
		{
			//@class Ames.InventoryOverride.InventoryOverride.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
